export default __webpack_public_path__ + "static/media/orange_plus.2d17009e.svg";